export default {
  DEVICE_ISSUE_HEADING: `athenaTelehealth està teniendo problemas con tus dispositivos`,
  DEVICE_ISSUE_INSTRUCTIONS: `Comprueba que tu càmara y tu micròfono tengan los cables conectados y que estèn encendidos. Luego haz clic en "Volver a intentar" para comenzar de nuevo.`,
};
